// This file is auto-generated by @hey-api/openapi-ts

import {
  type Client,
  formDataBodySerializer,
  type Options as Options2,
  type TDataShape,
} from "./client";
import { client } from "./client.gen";
import type {
  ApplyOrgScenarioData,
  ApplyOrgScenarioErrors,
  ApplyOrgScenarioResponses,
  ApproveOrgScenarioData,
  ApproveOrgScenarioErrors,
  ApproveOrgScenarioResponses,
  ApproveWorkforceChangeData,
  ApproveWorkforceChangeErrors,
  ApproveWorkforceChangeResponses,
  ArchiveOrgScenarioData,
  ArchiveOrgScenarioErrors,
  ArchiveOrgScenarioResponses,
  CancelOffboardingData,
  CancelOffboardingErrors,
  CancelOffboardingResponses,
  ConfirmOrgAdhocData,
  ConfirmOrgAdhocErrors,
  ConfirmOrgAdhocResponses,
  CreateBlankOrgScenarioData,
  CreateBlankOrgScenarioErrors,
  CreateBlankOrgScenarioResponses,
  CreateOffboardingData,
  CreateOffboardingErrors,
  CreateOffboardingResponses,
  CreateOrgAdhocData,
  CreateOrgAdhocErrors,
  CreateOrgAdhocResponses,
  CreateOrgScenarioData,
  CreateOrgScenarioErrors,
  CreateOrgScenarioResponses,
  CreateRiskFlagData,
  CreateRiskFlagErrors,
  CreateRiskFlagResponses,
  DeleteOrgChangeData,
  DeleteOrgChangeErrors,
  DeleteOrgChangeResponses,
  DeleteOrgScenarioData,
  DeleteOrgScenarioErrors,
  DeleteOrgScenarioResponses,
  ExpireRiskFlagData,
  ExpireRiskFlagErrors,
  ExpireRiskFlagResponses,
  ExportOrgScenarioPs1Data,
  ExportOrgScenarioPs1Errors,
  ExportOrgScenarioPs1Responses,
  ExportOrgScenarioXlsxData,
  ExportOrgScenarioXlsxErrors,
  ExportOrgScenarioXlsxResponses,
  ExportWorkforceXlsxData,
  ExportWorkforceXlsxResponses,
  GetAdminStatusData,
  GetAdminStatusResponses,
  GetHealthData,
  GetHealthResponses,
  GetMeData,
  GetMeResponses,
  GetOffboardingData,
  GetOffboardingErrors,
  GetOffboardingResponses,
  GetOrgAdhocData,
  GetOrgAdhocErrors,
  GetOrgAdhocResponses,
  GetOrgScenarioData,
  GetOrgScenarioErrors,
  GetOrgScenarioResponses,
  GetOrgSnapshotData,
  GetOrgSnapshotResponses,
  GetWorkforceChangeData,
  GetWorkforceChangeErrors,
  GetWorkforceChangeResponses,
  GetWorkforceLogData,
  GetWorkforceLogErrors,
  GetWorkforceLogResponses,
  GetWorkforceVocabData,
  GetWorkforceVocabResponses,
  ListAccessGroupsData,
  ListAccessGroupsResponses,
  ListFeedFlagsData,
  ListFeedFlagsResponses,
  ListFeedLeaversData,
  ListFeedLeaversErrors,
  ListFeedLeaversResponses,
  ListFutureHiresData,
  ListFutureHiresResponses,
  ListOffboardingsData,
  ListOffboardingsErrors,
  ListOffboardingsResponses,
  ListOrgScenariosData,
  ListOrgScenariosErrors,
  ListOrgScenariosResponses,
  ListRiskFlagsData,
  ListRiskFlagsErrors,
  ListRiskFlagsResponses,
  ListWorkforceChangesData,
  ListWorkforceChangesErrors,
  ListWorkforceChangesResponses,
  LogoutData,
  LogoutResponses,
  LookUpDirectoryUserData,
  LookUpDirectoryUserErrors,
  LookUpDirectoryUserResponses,
  PreviewOrgImportData,
  PreviewOrgImportErrors,
  PreviewOrgImportResponses,
  PutOrgChangeData,
  PutOrgChangeErrors,
  PutOrgChangeResponses,
  RefreshOrgSnapshotData,
  RefreshOrgSnapshotResponses,
  ReinstateOffboardingData,
  ReinstateOffboardingErrors,
  ReinstateOffboardingResponses,
  ReopenOrgScenarioData,
  ReopenOrgScenarioErrors,
  ReopenOrgScenarioResponses,
  RequestAccessAddData,
  RequestAccessAddErrors,
  RequestAccessAddResponses,
  RequestAccessRemoveData,
  RequestAccessRemoveErrors,
  RequestAccessRemoveResponses,
  RestoreOrgScenarioData,
  RestoreOrgScenarioErrors,
  RestoreOrgScenarioResponses,
  RetryAccessRequestData,
  RetryAccessRequestErrors,
  RetryAccessRequestResponses,
  RetryOrgScenarioData,
  RetryOrgScenarioErrors,
  RetryOrgScenarioResponses,
  ReturnWorkforceChangeData,
  ReturnWorkforceChangeErrors,
  ReturnWorkforceChangeResponses,
  RevertOffboardingData,
  RevertOffboardingErrors,
  RevertOffboardingResponses,
  SearchDirectoryUsersData,
  SearchDirectoryUsersErrors,
  SearchDirectoryUsersResponses,
  SubmitEmployeeChangeData,
  SubmitEmployeeChangeErrors,
  SubmitEmployeeChangeResponses,
  SubmitFutureHireData,
  SubmitFutureHireErrors,
  SubmitFutureHireResponses,
  SubmitPlannedExitData,
  SubmitPlannedExitErrors,
  SubmitPlannedExitResponses,
  TestOrgScenarioData,
  TestOrgScenarioErrors,
  TestOrgScenarioResponses,
  UndoOrgScenarioData,
  UndoOrgScenarioErrors,
  UndoOrgScenarioResponses,
  UpdateEmployeeChangeData,
  UpdateEmployeeChangeErrors,
  UpdateEmployeeChangeResponses,
  UpdateFutureHireData,
  UpdateFutureHireErrors,
  UpdateFutureHireResponses,
  UpdateOrgScenarioData,
  UpdateOrgScenarioErrors,
  UpdateOrgScenarioResponses,
  UpdatePlannedExitData,
  UpdatePlannedExitErrors,
  UpdatePlannedExitResponses,
  WithdrawWorkforceChangeData,
  WithdrawWorkforceChangeErrors,
  WithdrawWorkforceChangeResponses,
} from "./types.gen";

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
  TResponse = unknown,
> = Options2<TData, ThrowOnError, TResponse> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>;
};

/**
 * List offboardings, newest first
 *
 * Return the queue table.
 *
 * Ordered by ``created_at`` descending — the queue is a work list, so the most
 * recently requested offboarding is the one most likely to need attention.
 * ``total`` counts the rows matching the current filter (not the whole table),
 * so a caller can page through a filtered view without recounting.
 *
 * Reading this never touches the tenant; every row here is database state.
 */
export const listOffboardings = <ThrowOnError extends boolean = false>(
  options?: Options<ListOffboardingsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<ListOffboardingsResponses, ListOffboardingsErrors, ThrowOnError>({
    url: "/offboarding",
    ...options,
  });

/**
 * Schedule an offboarding (writes a row; nothing executes yet)
 *
 * Record a leaver at status ``scheduled`` and log who asked for it.
 *
 * This writes database rows and nothing else. Nothing in this API disables
 * an account, revokes a session or delegates a mailbox: the worker
 * application holds those permissions and runs on its own schedule. Whether
 * it is switched on is reported by ``GET /admin``, to the people who can
 * change it — not on the screens HR reads every day.
 *
 * The requester is the signed-in session, never a UPN from the body.
 */
export const createOffboarding = <ThrowOnError extends boolean = false>(
  options: Options<CreateOffboardingData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    CreateOffboardingResponses,
    CreateOffboardingErrors,
    ThrowOnError
  >({
    url: "/leaver",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * One offboarding with its action log and the subject's risk flags
 *
 * Read a single leaver record. Reads are not logged — only changes are.
 */
export const getOffboarding = <ThrowOnError extends boolean = false>(
  options: Options<GetOffboardingData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetOffboardingResponses, GetOffboardingErrors, ThrowOnError>({
    url: "/leaver/{offboarding_id}",
    ...options,
  });

/**
 * Revert a wrongful offboarding (database only)
 *
 * Mark the record ``reverted`` and append the reason to the action log.
 *
 * HR owns wrongful disables, so this needs no approval — but it also does not
 * re-enable anything in the tenant. It changes this database and records who
 * decided, which is the part Entra's audit log can never show.
 *
 * Rejected with 409 when the record is already reverted or cancelled: the
 * denial is logged too, so an attempted double-revert is visible afterwards.
 */
export const revertOffboarding = <ThrowOnError extends boolean = false>(
  options: Options<RevertOffboardingData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    RevertOffboardingResponses,
    RevertOffboardingErrors,
    ThrowOnError
  >({
    url: "/leaver/{offboarding_id}/revert",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Cancel a scheduled offboarding before it runs
 *
 * Cancel a record that has not run. Only valid from status ``scheduled``.
 *
 * Anything further along is reverted, not cancelled — a 409 says which.
 */
export const cancelOffboarding = <ThrowOnError extends boolean = false>(
  options: Options<CancelOffboardingData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    CancelOffboardingResponses,
    CancelOffboardingErrors,
    ThrowOnError
  >({
    url: "/leaver/{offboarding_id}/cancel",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Put the person back: re-enable the account in both directories
 *
 * Ask the worker to enable this account again, in Entra and in on-prem AD.
 *
 * This is the difference between revert and reinstate, and it is worth being
 * exact about: revert marks the RECORD and touches nothing; reinstate changes
 * the TENANT. So it is only offered where HROps did the disabling — a record
 * whose phase 1 ran — and never as a free-text "enable this UPN", which would
 * turn an HR tool into a way to switch on an account SecOps disabled during an
 * incident.
 *
 * The API does not do the enabling. It sets `reinstating`, and the worker
 * picks it up on its next pass, through the same steps, guardrails and
 * append-only log as every other write. The record therefore never claims the
 * person is back before anything has actually happened.
 */
export const reinstateOffboarding = <ThrowOnError extends boolean = false>(
  options: Options<ReinstateOffboardingData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ReinstateOffboardingResponses,
    ReinstateOffboardingErrors,
    ThrowOnError
  >({
    url: "/leaver/{offboarding_id}/reinstate",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List Risk Flags
 *
 * List risk flags, soonest expiry first.
 *
 * Active means ``expired_at IS NULL`` and ``ends_at`` still in the future.
 * The call appends a ``riskflag.read`` row: looking at who is flagged is
 * itself an audit event.
 */
export const listRiskFlags = <ThrowOnError extends boolean = false>(
  options?: Options<ListRiskFlagsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<ListRiskFlagsResponses, ListRiskFlagsErrors, ThrowOnError>({
    url: "/flags",
    ...options,
  });

/**
 * Create Risk Flag
 *
 * Raise a time-boxed risk flag.
 *
 * ``ends_at`` is mandatory — a request without it is rejected by the schema
 * (422) — and must be after ``starts_at``, which this route rejects with a
 * 400 and a denied ``action_log`` row before the database check constraint
 * would.
 *
 * A low or medium flag changes nothing in the tenant. **A HIGH flag does**:
 * the worker puts the person into the Entra group the Purview policies
 * target, which blocks their uploads, their USB copies and their outbound
 * attachments. That makes this route a tenant-writing route in disguise, so a
 * high flag runs the same subject checks an offboarding does — directory role
 * holders, the protected administrative unit and break-glass accounts are
 * refused, and a directory that cannot be read is refused too.
 */
export const createRiskFlag = <ThrowOnError extends boolean = false>(
  options: Options<CreateRiskFlagData, ThrowOnError>,
) =>
  (options.client ?? client).post<CreateRiskFlagResponses, CreateRiskFlagErrors, ThrowOnError>({
    url: "/flags",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Expire Risk Flag
 *
 * Retire a flag now, before its window ends.
 *
 * Sets ``expired_at``; the row itself stays for the record. Expiring an
 * already-expired flag is a 409 rather than a silent no-op, so the log never
 * implies a second retirement happened.
 *
 * Anyone using HROps may retire any flag: HR covers for each other, and the
 * log names who retired it. Withdrawing a colleague's flag is visible, not
 * prevented.
 */
export const expireRiskFlag = <ThrowOnError extends boolean = false>(
  options: Options<ExpireRiskFlagData, ThrowOnError>,
) =>
  (options.client ?? client).post<ExpireRiskFlagResponses, ExpireRiskFlagErrors, ThrowOnError>({
    url: "/flags/{flag_id}/expire",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Operational status of this deployment
 *
 * Answer 'is HROps working' from the record, not from a synthetic probe.
 */
export const getAdminStatus = <ThrowOnError extends boolean = false>(
  options?: Options<GetAdminStatusData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetAdminStatusResponses, unknown, ThrowOnError>({
    url: "/admin",
    ...options,
  });

/**
 * List Access Groups
 *
 * The managed groups with their live membership and open requests.
 *
 * Reads the directory as the app. An unconfigured feature answers with an
 * empty list rather than an error, so the page can simply not exist.
 */
export const listAccessGroups = <ThrowOnError extends boolean = false>(
  options?: Options<ListAccessGroupsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<ListAccessGroupsResponses, unknown, ThrowOnError>({
    url: "/access",
    ...options,
  });

/**
 * Request Access Add
 *
 * Ask for a person to be added. Applied by the worker on its next pass.
 */
export const requestAccessAdd = <ThrowOnError extends boolean = false>(
  options: Options<RequestAccessAddData, ThrowOnError>,
) =>
  (options.client ?? client).post<RequestAccessAddResponses, RequestAccessAddErrors, ThrowOnError>({
    url: "/access/{group_id}/members",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Request Access Remove
 *
 * Ask for a person to be removed. A reason is mandatory.
 */
export const requestAccessRemove = <ThrowOnError extends boolean = false>(
  options: Options<RequestAccessRemoveData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    RequestAccessRemoveResponses,
    RequestAccessRemoveErrors,
    ThrowOnError
  >({
    url: "/access/{group_id}/members/remove",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Retry Access Request
 *
 * Put a failed request back in the queue. Only failed rows; nothing else moves.
 */
export const retryAccessRequest = <ThrowOnError extends boolean = false>(
  options: Options<RetryAccessRequestData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    RetryAccessRequestResponses,
    RetryAccessRequestErrors,
    ThrowOnError
  >({ url: "/access/requests/{request_id}/retry", ...options });

/**
 * Get Snapshot
 *
 * The newest snapshot, every chartable account. One fetch; the page
 * filters and draws client-side.
 */
export const getOrgSnapshot = <ThrowOnError extends boolean = false>(
  options?: Options<GetOrgSnapshotData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetOrgSnapshotResponses, unknown, ThrowOnError>({
    url: "/org/snapshot",
    ...options,
  });

/**
 * Refresh Snapshot
 *
 * Read the whole directory now and freeze it as the new baseline.
 */
export const refreshOrgSnapshot = <ThrowOnError extends boolean = false>(
  options?: Options<RefreshOrgSnapshotData, ThrowOnError>,
) =>
  (options?.client ?? client).post<RefreshOrgSnapshotResponses, unknown, ThrowOnError>({
    url: "/org/snapshot/refresh",
    ...options,
  });

/**
 * Preview Import
 *
 * Read a workbook and say what every row would change. Writes nothing
 * except the log row; the file is not kept.
 */
export const previewOrgImport = <ThrowOnError extends boolean = false>(
  options: Options<PreviewOrgImportData, ThrowOnError>,
) =>
  (options.client ?? client).post<PreviewOrgImportResponses, PreviewOrgImportErrors, ThrowOnError>({
    ...formDataBodySerializer,
    url: "/org/imports/preview",
    ...options,
    headers: {
      "Content-Type": null,
      ...options.headers,
    },
  });

/**
 * List Scenarios
 *
 * Scenarios by default. Ad-hoc changes share the table but belong in
 * their own list — mixing a hundred one-line account edits into the
 * target-structure list would bury the scenarios.
 */
export const listOrgScenarios = <ThrowOnError extends boolean = false>(
  options?: Options<ListOrgScenariosData, ThrowOnError>,
) =>
  (options?.client ?? client).get<ListOrgScenariosResponses, ListOrgScenariosErrors, ThrowOnError>({
    url: "/org/scenarios",
    ...options,
  });

/**
 * Create Scenario
 *
 * Commit an import: the same evaluation again, server-side, with the
 * human's picks, and every `change` row stored. Rows still needing a pick
 * are left out and stay visible in the stored report.
 */
export const createOrgScenario = <ThrowOnError extends boolean = false>(
  options: Options<CreateOrgScenarioData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    CreateOrgScenarioResponses,
    CreateOrgScenarioErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    url: "/org/scenarios",
    ...options,
    headers: {
      "Content-Type": null,
      ...options.headers,
    },
  });

/**
 * Create Blank Scenario
 *
 * A scenario with no file behind it, against the newest snapshot. Changes
 * are then added by hand, person by person, like any draft.
 */
export const createBlankOrgScenario = <ThrowOnError extends boolean = false>(
  options: Options<CreateBlankOrgScenarioData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    CreateBlankOrgScenarioResponses,
    CreateBlankOrgScenarioErrors,
    ThrowOnError
  >({
    url: "/org/scenarios/blank",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete Scenario
 *
 * Delete for good. Refused once anything was written to AD: that scenario
 * is the record of what was changed, and it can only be archived.
 */
export const deleteOrgScenario = <ThrowOnError extends boolean = false>(
  options: Options<DeleteOrgScenarioData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteOrgScenarioResponses,
    DeleteOrgScenarioErrors,
    ThrowOnError
  >({ url: "/org/scenarios/{scenario_id}", ...options });

/**
 * Get Scenario
 */
export const getOrgScenario = <ThrowOnError extends boolean = false>(
  options: Options<GetOrgScenarioData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetOrgScenarioResponses, GetOrgScenarioErrors, ThrowOnError>({
    url: "/org/scenarios/{scenario_id}",
    ...options,
  });

/**
 * Update Scenario
 *
 * Rename or describe. Allowed in every state: it changes no directory value.
 */
export const updateOrgScenario = <ThrowOnError extends boolean = false>(
  options: Options<UpdateOrgScenarioData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    UpdateOrgScenarioResponses,
    UpdateOrgScenarioErrors,
    ThrowOnError
  >({
    url: "/org/scenarios/{scenario_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Export Xlsx
 */
export const exportOrgScenarioXlsx = <ThrowOnError extends boolean = false>(
  options: Options<ExportOrgScenarioXlsxData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    ExportOrgScenarioXlsxResponses,
    ExportOrgScenarioXlsxErrors,
    ThrowOnError
  >({ url: "/org/scenarios/{scenario_id}/export.xlsx", ...options });

/**
 * Export Ps1
 */
export const exportOrgScenarioPs1 = <ThrowOnError extends boolean = false>(
  options: Options<ExportOrgScenarioPs1Data, ThrowOnError>,
) =>
  (options.client ?? client).get<
    ExportOrgScenarioPs1Responses,
    ExportOrgScenarioPs1Errors,
    ThrowOnError
  >({ url: "/org/scenarios/{scenario_id}/export.ps1", ...options });

/**
 * Archive Scenario
 */
export const archiveOrgScenario = <ThrowOnError extends boolean = false>(
  options: Options<ArchiveOrgScenarioData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ArchiveOrgScenarioResponses,
    ArchiveOrgScenarioErrors,
    ThrowOnError
  >({ url: "/org/scenarios/{scenario_id}/archive", ...options });

/**
 * Restore Scenario
 */
export const restoreOrgScenario = <ThrowOnError extends boolean = false>(
  options: Options<RestoreOrgScenarioData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    RestoreOrgScenarioResponses,
    RestoreOrgScenarioErrors,
    ThrowOnError
  >({ url: "/org/scenarios/{scenario_id}/restore", ...options });

/**
 * Put Change
 *
 * Add a change by hand, or replace the proposed value for that person and
 * field. Draft only. `old` always comes from the baseline, never the caller.
 */
export const putOrgChange = <ThrowOnError extends boolean = false>(
  options: Options<PutOrgChangeData, ThrowOnError>,
) =>
  (options.client ?? client).post<PutOrgChangeResponses, PutOrgChangeErrors, ThrowOnError>({
    url: "/org/scenarios/{scenario_id}/changes",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete Change
 */
export const deleteOrgChange = <ThrowOnError extends boolean = false>(
  options: Options<DeleteOrgChangeData, ThrowOnError>,
) =>
  (options.client ?? client).delete<DeleteOrgChangeResponses, DeleteOrgChangeErrors, ThrowOnError>({
    url: "/org/scenarios/{scenario_id}/changes/{change_id}",
    ...options,
  });

/**
 * Approve Scenario
 *
 * Freeze it. Refused while the simulation still reports an error.
 */
export const approveOrgScenario = <ThrowOnError extends boolean = false>(
  options: Options<ApproveOrgScenarioData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ApproveOrgScenarioResponses,
    ApproveOrgScenarioErrors,
    ThrowOnError
  >({ url: "/org/scenarios/{scenario_id}/approve", ...options });

/**
 * Reopen Scenario
 *
 * Back to draft for editing. A test result is thrown away with it: it
 * described the frozen version, not the one about to be edited.
 */
export const reopenOrgScenario = <ThrowOnError extends boolean = false>(
  options: Options<ReopenOrgScenarioData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ReopenOrgScenarioResponses,
    ReopenOrgScenarioErrors,
    ThrowOnError
  >({ url: "/org/scenarios/{scenario_id}/reopen", ...options });

/**
 * Test Scenario
 *
 * Ask the worker to read every target in AD and say what it would do.
 */
export const testOrgScenario = <ThrowOnError extends boolean = false>(
  options: Options<TestOrgScenarioData, ThrowOnError>,
) =>
  (options.client ?? client).post<TestOrgScenarioResponses, TestOrgScenarioErrors, ThrowOnError>({
    url: "/org/scenarios/{scenario_id}/test",
    ...options,
  });

/**
 * Apply Scenario
 *
 * Ask the worker to write the changes to AD on its next pass.
 *
 * Needs a test run on the approved version first: the button that writes to
 * AD is never the first thing that reads it.
 */
export const applyOrgScenario = <ThrowOnError extends boolean = false>(
  options: Options<ApplyOrgScenarioData, ThrowOnError>,
) =>
  (options.client ?? client).post<ApplyOrgScenarioResponses, ApplyOrgScenarioErrors, ThrowOnError>({
    url: "/org/scenarios/{scenario_id}/apply",
    ...options,
  });

/**
 * Retry Scenario
 *
 * After a partial apply: try the failed changes again. Drift and refusals
 * stay as they are — they need a decision, not another attempt.
 */
export const retryOrgScenario = <ThrowOnError extends boolean = false>(
  options: Options<RetryOrgScenarioData, ThrowOnError>,
) =>
  (options.client ?? client).post<RetryOrgScenarioResponses, RetryOrgScenarioErrors, ThrowOnError>({
    url: "/org/scenarios/{scenario_id}/retry",
    ...options,
  });

/**
 * Create Adhoc
 *
 * Prepare an ad-hoc change. This writes nothing to AD — it builds the
 * change and hands back exactly what will be written, for confirming.
 */
export const createOrgAdhoc = <ThrowOnError extends boolean = false>(
  options: Options<CreateOrgAdhocData, ThrowOnError>,
) =>
  (options.client ?? client).post<CreateOrgAdhocResponses, CreateOrgAdhocErrors, ThrowOnError>({
    url: "/org/adhoc",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Adhoc
 *
 * Re-read one ad-hoc change — the confirmation screen on a reload, and the
 * result screen once the worker has been through it.
 */
export const getOrgAdhoc = <ThrowOnError extends boolean = false>(
  options: Options<GetOrgAdhocData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetOrgAdhocResponses, GetOrgAdhocErrors, ThrowOnError>({
    url: "/org/adhoc/{scenario_id}",
    ...options,
  });

/**
 * Confirm Adhoc
 *
 * Write it. The worker picks it up on its next pass, checks that AD still
 * holds the old value, writes, reads back, and verifies in Entra.
 *
 * There is no separate test step here, unlike a scenario: the preview the
 * caller just confirmed is the test, and the worker refuses any change whose
 * current AD value has moved since. Skipping a dry run cannot write a wrong
 * value — it can only report a drift one pass later.
 */
export const confirmOrgAdhoc = <ThrowOnError extends boolean = false>(
  options: Options<ConfirmOrgAdhocData, ThrowOnError>,
) =>
  (options.client ?? client).post<ConfirmOrgAdhocResponses, ConfirmOrgAdhocErrors, ThrowOnError>({
    url: "/org/adhoc/{scenario_id}/confirm",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Undo Scenario
 *
 * Prepare the reversal of what this change actually wrote to AD.
 */
export const undoOrgScenario = <ThrowOnError extends boolean = false>(
  options: Options<UndoOrgScenarioData, ThrowOnError>,
) =>
  (options.client ?? client).post<UndoOrgScenarioResponses, UndoOrgScenarioErrors, ThrowOnError>({
    url: "/org/scenarios/{scenario_id}/undo",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Vocab
 */
export const getWorkforceVocab = <ThrowOnError extends boolean = false>(
  options?: Options<GetWorkforceVocabData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetWorkforceVocabResponses, unknown, ThrowOnError>({
    url: "/workforce/vocab",
    ...options,
  });

/**
 * List Changes
 */
export const listWorkforceChanges = <ThrowOnError extends boolean = false>(
  options?: Options<ListWorkforceChangesData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    ListWorkforceChangesResponses,
    ListWorkforceChangesErrors,
    ThrowOnError
  >({ url: "/workforce", ...options });

/**
 * List Future Hires
 *
 * The Future Hire IDs a new hire can be linked to, with who already
 * filled each one, so a position is not filled twice.
 */
export const listFutureHires = <ThrowOnError extends boolean = false>(
  options?: Options<ListFutureHiresData, ThrowOnError>,
) =>
  (options?.client ?? client).get<ListFutureHiresResponses, unknown, ThrowOnError>({
    url: "/workforce/future-hires",
    ...options,
  });

/**
 * Export Xlsx
 *
 * Every record as a workbook, one sheet per form. Compensation columns
 * only for the approvers — the spreadsheet Laura asked for Carlyne to get.
 */
export const exportWorkforceXlsx = <ThrowOnError extends boolean = false>(
  options?: Options<ExportWorkforceXlsxData, ThrowOnError>,
) =>
  (options?.client ?? client).get<ExportWorkforceXlsxResponses, unknown, ThrowOnError>({
    url: "/workforce/export.xlsx",
    ...options,
  });

/**
 * Submit Employee Change
 */
export const submitEmployeeChange = <ThrowOnError extends boolean = false>(
  options: Options<SubmitEmployeeChangeData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    SubmitEmployeeChangeResponses,
    SubmitEmployeeChangeErrors,
    ThrowOnError
  >({
    url: "/workforce/employee-change",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Submit Planned Exit
 */
export const submitPlannedExit = <ThrowOnError extends boolean = false>(
  options: Options<SubmitPlannedExitData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    SubmitPlannedExitResponses,
    SubmitPlannedExitErrors,
    ThrowOnError
  >({
    url: "/workforce/planned-exit",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Submit Future Hire
 *
 * The Future Hire ID is assigned here, centrally, on submission.
 */
export const submitFutureHire = <ThrowOnError extends boolean = false>(
  options: Options<SubmitFutureHireData, ThrowOnError>,
) =>
  (options.client ?? client).post<SubmitFutureHireResponses, SubmitFutureHireErrors, ThrowOnError>({
    url: "/workforce/future-hire",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Update Employee Change
 */
export const updateEmployeeChange = <ThrowOnError extends boolean = false>(
  options: Options<UpdateEmployeeChangeData, ThrowOnError>,
) =>
  (options.client ?? client).put<
    UpdateEmployeeChangeResponses,
    UpdateEmployeeChangeErrors,
    ThrowOnError
  >({
    url: "/workforce/employee-change/{wid}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Update Planned Exit
 */
export const updatePlannedExit = <ThrowOnError extends boolean = false>(
  options: Options<UpdatePlannedExitData, ThrowOnError>,
) =>
  (options.client ?? client).put<UpdatePlannedExitResponses, UpdatePlannedExitErrors, ThrowOnError>(
    {
      url: "/workforce/planned-exit/{wid}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    },
  );

/**
 * Update Future Hire
 */
export const updateFutureHire = <ThrowOnError extends boolean = false>(
  options: Options<UpdateFutureHireData, ThrowOnError>,
) =>
  (options.client ?? client).put<UpdateFutureHireResponses, UpdateFutureHireErrors, ThrowOnError>({
    url: "/workforce/future-hire/{wid}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Log
 *
 * The audit trail of the Workforce page, newest first.
 *
 * Timo, 6 Oct 2026: "we also need a proper log for this workforce thing".
 * This is `action_log` filtered to what this page did, not a second log: the
 * rows are the same append-only ones every other screen writes, so what is
 * shown here is exactly what an auditor would get from the table.
 */
export const getWorkforceLog = <ThrowOnError extends boolean = false>(
  options?: Options<GetWorkforceLogData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetWorkforceLogResponses, GetWorkforceLogErrors, ThrowOnError>({
    url: "/workforce/log",
    ...options,
  });

/**
 * Get Change
 */
export const getWorkforceChange = <ThrowOnError extends boolean = false>(
  options: Options<GetWorkforceChangeData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetWorkforceChangeResponses,
    GetWorkforceChangeErrors,
    ThrowOnError
  >({ url: "/workforce/{wid}", ...options });

/**
 * Withdraw
 */
export const withdrawWorkforceChange = <ThrowOnError extends boolean = false>(
  options: Options<WithdrawWorkforceChangeData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    WithdrawWorkforceChangeResponses,
    WithdrawWorkforceChangeErrors,
    ThrowOnError
  >({
    url: "/workforce/{wid}/withdraw",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Send Back
 *
 * Send it back to the submitter with a note. They edit and resubmit.
 */
export const returnWorkforceChange = <ThrowOnError extends boolean = false>(
  options: Options<ReturnWorkforceChangeData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ReturnWorkforceChangeResponses,
    ReturnWorkforceChangeErrors,
    ThrowOnError
  >({
    url: "/workforce/{wid}/return",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Approve
 *
 * Approve, and do what the record implies. See the module docstring for
 * what each kind triggers; `outcome` on the record says what happened.
 */
export const approveWorkforceChange = <ThrowOnError extends boolean = false>(
  options: Options<ApproveWorkforceChangeData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ApproveWorkforceChangeResponses,
    ApproveWorkforceChangeErrors,
    ThrowOnError
  >({
    url: "/workforce/{wid}/approve",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List Feed Leavers
 *
 * Leaver records for the dashboard, newest change first. Read-only.
 */
export const listFeedLeavers = <ThrowOnError extends boolean = false>(
  options?: Options<ListFeedLeaversData, ThrowOnError>,
) =>
  (options?.client ?? client).get<ListFeedLeaversResponses, ListFeedLeaversErrors, ThrowOnError>({
    url: "/feed/leavers",
    ...options,
  });

/**
 * List Feed Flags
 *
 * Active risk flags for the dashboard, soonest expiry first. Read-only.
 *
 * Active means not retired early and inside its window right now.
 */
export const listFeedFlags = <ThrowOnError extends boolean = false>(
  options?: Options<ListFeedFlagsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<ListFeedFlagsResponses, unknown, ThrowOnError>({
    url: "/feed/flags",
    ...options,
  });

/**
 * Health
 *
 * Return a simple health status payload.
 */
export const getHealth = <ThrowOnError extends boolean = false>(
  options?: Options<GetHealthData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetHealthResponses, unknown, ThrowOnError>({
    url: "/health",
    ...options,
  });

/**
 * Directory Search
 *
 * Find the person HR means, so they pick rather than type.
 *
 * A capped search behind a session, over name / sign-in name / mail. It
 * returns people, not a browsable directory: the cap is small and a query
 * shorter than two characters returns nothing.
 */
export const searchDirectoryUsers = <ThrowOnError extends boolean = false>(
  options: Options<SearchDirectoryUsersData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    SearchDirectoryUsersResponses,
    SearchDirectoryUsersErrors,
    ThrowOnError
  >({ url: "/directory/search", ...options });

/**
 * Directory Lookup
 *
 * Resolve a UPN so HR can see who they have named, before they save it.
 *
 * Behind a session like every other route, and a read of one named user: not
 * a search, not a browse. The app's own managed identity does the reading, so
 * no HR user needs directory rights of their own.
 */
export const lookUpDirectoryUser = <ThrowOnError extends boolean = false>(
  options: Options<LookUpDirectoryUserData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    LookUpDirectoryUserResponses,
    LookUpDirectoryUserErrors,
    ThrowOnError
  >({ url: "/directory/lookup", ...options });

/**
 * Auth Logout
 *
 * Sign out — clear the session cookie.
 */
export const logout = <ThrowOnError extends boolean = false>(
  options?: Options<LogoutData, ThrowOnError>,
) =>
  (options?.client ?? client).post<LogoutResponses, unknown, ThrowOnError>({
    url: "/auth/logout",
    ...options,
  });

/**
 * Auth Me
 *
 * Return the current session's identity and what it may do.
 */
export const getMe = <ThrowOnError extends boolean = false>(
  options?: Options<GetMeData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetMeResponses, unknown, ThrowOnError>({
    url: "/auth/me",
    ...options,
  });
